import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
import { PentairInfoLabel } from '../../components/info-label';
import { withFormData } from '../with-form-data';
export const PentairTextField = withFormData(({ label, description, ...props }) => {
    return (_jsx(TextField, { "aria-label": label, label: _jsx(PentairInfoLabel, { title: label, description: description, error: props.error, disabled: props.disabled, selectTooltip: props?.selectTooltip }), ...props }));
});
